import React from 'react';
import PropTypes from 'prop-types';
import {locationShape, withRouter} from 'react-router';

@withRouter
class FormHandler extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    location: locationShape.isRequired,
    method: PropTypes.oneOf(['GET', 'POST', 'PUT', 'DELETE']),
    onReceiveForm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    method: 'POST',
  };

  UNSAFE_componentWillMount() {
    this.handleSubmit();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.location && nextProps.location &&
      this.props.location.state !== nextProps.location.state
    ) {
      this.handleSubmit(nextProps);
    }
  }

  handleSubmit(props = this.props) {
    const state = props.location && props.location.state;
    if (
      state &&
      state.method === props.method &&
      !state.handled
    ) {
      state.handled = true; // don't handle the same request twice (esp. server-side)
      props.onReceiveForm(state);
    }
  }

  render() {
    return React.Children.only(this.props.children);
  }
}

export default FormHandler;



// WEBPACK FOOTER //
// ./spa/Components/Form/FormHandler.jsx